import { Box, Link, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

export default (): ReactElement => {
  let error = useRouteError()

  // eslint-disable-next-line no-console
  console.error(error)

  let errorMessage = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error'

  let errorStack =
    error instanceof Error ? error.stack : JSON.stringify(error, null, 2)

  return (
    <Box sx={{ backgroundColor: 'background.default' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <Typography sx={{ my: 1 }}>An unexpected error occurred.</Typography>
        <Typography>
          If this error persists, you may{' '}
          <Link
            href="https://foamfrat.my.site.com/support/s/"
            target="_blank"
            sx={{ textDecoration: 'none' }}
          >
            contact support
          </Link>
          .
        </Typography>

        {import.meta.env.DEV && (
          <Box
            sx={{
              mt: 3,
              mx: 2,
              p: 2,
              maxWidth: 800,
              width: '100%',
              bgcolor: 'background.paper',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'error.main',
            }}
          >
            <Typography variant="subtitle2" color="error.main" sx={{ mb: 1 }}>
              {errorMessage}
            </Typography>
            {errorStack && (
              <Box
                component="pre"
                sx={{
                  fontSize: '0.75rem',
                  overflow: 'auto',
                  maxHeight: 400,
                  color: 'text.secondary',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  m: 0,
                }}
              >
                {errorStack}
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}
